/* Luveqo UI helpers (replaces final-polish.js, final-collection-hero.js, card-hero-final.js, luveqo-quickadd-fix.js)
   - Touch devices: tapping a product card marks it "is-touch-hover" so the secondary image swap runs.
     Quick Add / wishlist are always visible on touch screens (CSS), so no tap is ever swallowed.
   - Quick Add button: shows a brief "adding" state while the popup loads.
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    document.documentElement.classList.add('vision-polish-ready');
    var touchLike = window.matchMedia('(hover: none), (pointer: coarse)');

    function clearCards(except) {
      document.querySelectorAll('.product-card.is-touch-hover').forEach(function (c) {
        if (c !== except) c.classList.remove('is-touch-hover');
      });
    }

    document.addEventListener('touchstart', function (e) {
      if (!touchLike.matches) return;
      var card = e.target.closest ? e.target.closest('.product-card') : null;
      clearCards(card);
      if (card) card.classList.add('is-touch-hover');
    }, { passive: true });

    /* Quick add: visual feedback on the card button while the popup fetches. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.product-card__quick-add .quick-add-btn') : null;
      if (!btn) return;
      btn.classList.add('is-adding');
      window.setTimeout(function () { btn.classList.remove('is-adding'); }, 900);
    });

    window.addEventListener('pageshow', function () {
      document.documentElement.classList.add('vision-polish-ready');
    });
  });
}());
